var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nav-6-a",
    d: "M0 0L31.999 0 31.999 28 0 28z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nav-6-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nav-6-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.9992,24 C29.9992,25.104 29.1052,26 27.9992,26 L25.9992,26 L25.9992,16 L27.9992,16 C29.1052,16 29.9992,16.896 29.9992,18 L29.9992,24 Z M5.9992,26 L3.9992,26 C2.8932,26 1.9992,25.104 1.9992,24 L1.9992,18 C1.9992,16.896 2.8932,16 3.9992,16 L5.9992,16 L5.9992,26 Z M27.9992,14 L27.9992,12 C27.9992,5.374 22.6252,0 15.9992,0 C9.3732,0 3.9992,5.374 3.9992,12 L3.9992,14 C1.7912,14 -0.0008,15.792 -0.0008,18 L-0.0008,24 C-0.0008,26.208 1.7912,28 3.9992,28 L7.9992,28 L7.9992,14 L5.9992,14 L5.9992,12 C5.9992,6.478 10.4752,2 15.9992,2 C21.5232,2 25.9992,6.478 25.9992,12 L25.9992,14 L23.9992,14 L23.9992,28 L27.9992,28 C30.2072,28 31.9992,26.208 31.9992,24 L31.9992,18 C31.9992,15.792 30.2072,14 27.9992,14 L27.9992,14 Z",
    mask: "url(#nav-6-b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.9992,32 L16.9992,32 C16.4472,32 15.9992,31.552 15.9992,31 C15.9992,30.448 16.4472,30 16.9992,30 L25.9992,30 L25.9992,28 C25.9992,27.448 26.4472,27 26.9992,27 C27.5512,27 27.9992,27.448 27.9992,28 L27.9992,31 C27.9992,31.552 27.5512,32 26.9992,32"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/Headphones.fb2891f2.svg";
export { ForwardRef as ReactComponent };